import { InjectionToken } from "@angular/core";

export const PORTAL_PRODUCT_SHOW_QUERY_PARAM_TOKEN = new InjectionToken<boolean>("PORTAL_PRODUCT_SHOW_QUERY_PARAM");
